/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamSchvalovaciRoleEpk extends GContentBase<SeznamSchvalovaciRoleEpkObj> {
        private seznamObj: SeznamSchvalovaciRoleEpkObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamSchvalovaciRoleEpkObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamSchvalovaciRoleEpkNew",
                contentCaption: "jres:32131048", 
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_sro}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,ktg_sch_role_txt,ico,ixs_sro,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamSchvalovaciRoleEpkObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailSchvalovaciRoleEpk", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailSchvalovaciRoleEpk",
                newRecord: isNew,
                ixs_sro: isNew == true ? null : data.ixs_sro
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamFunkceSchvalovaciRoleEpk: {
                    icon: "fa-link",
                    caption: "jres:33000896", //RC 33000896 : Přiřazená funkční místa
                    run: (ev, ctx) => {
                        this.openSeznamFunkceSchvalovaciRoleEpk();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actSeznamFunkceSchvalovaciRoleEpk }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "actSeznamFunkceSchvalovaciRoleEpk*"
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.SchvalovaciRoleEpk.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actSeznamFunkceSchvalovaciRoleEpk?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_sro}`,
                nazev: data["nazev"]
            }
        }

        private openSeznamFunkceSchvalovaciRoleEpk() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciRoleEpk", { ixs_sro: activeRow.ixs_sro })
        }
    }
}